import { BG_PADRAO_TOTEM, ProtecaoTela, slidesComPadrao } from "@/components/protecao-tela"
import { useGetLojaAtualQuery } from "@/api"
import { useAvisarOcioso } from "@/lib/atualizacao-totem"
import { useDispatch } from "react-redux"
import { trocarView } from "./navegacao-kiosk"
import { useMemo } from "react"

export default function StartScreen() {
    const dispatch = useDispatch()
    const { data: loja } = useGetLojaAtualQuery()
    useAvisarOcioso(true)

    const slides = useMemo(() =>
        slidesComPadrao(
            (loja?.configuracao.imagensTotemCheckout ?? []).filter((u): u is string => !!u),
            BG_PADRAO_TOTEM,
        ), [loja])

    return (
        <ProtecaoTela
            slides={slides}
            chamadaAcima="Toque para"
            chamadaPrincipal="fazer seu pagamento!"
            nivel="tela"
            aoTocar={() => trocarView(dispatch, { currentView: 'VIEW_IDENTIFIER' })}
        />
    )
}
